import { render, staticRenderFns } from "./common-button.vue?vue&type=template&id=431d7e62&scoped=true"
import script from "./common-button.vue?vue&type=script&lang=js"
export * from "./common-button.vue?vue&type=script&lang=js"
import style0 from "./common-button.vue?vue&type=style&index=0&id=431d7e62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431d7e62",
  null
  
)

export default component.exports